import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Section } from 'common';
import strings from 'strings';
import FPIcon from 'UI/components/atoms/FPIcon';
import InfoLabel from 'UI/components/molecules/InfoLabel';
import { SvgCheck, SvgDelete } from 'UI/res';
import { isTruthyValue } from 'utils';

import { ICON_SIZE } from '../../constants';

const renderHasDirectReports = (hasDirectReports = null) => {
  if (!isTruthyValue(hasDirectReports)) return null;

  const Icon = hasDirectReports ? SvgCheck : SvgDelete;
  const colorSetter = hasDirectReports
    ? palette => palette.success.main
    : palette => palette.error.main;

  return <FPIcon component={Icon} onSetColor={colorSetter} size={ICON_SIZE} />;
};

export const ReportingStructure = ({ reportingStructure = null }) => {
  if (!reportingStructure) return null;

  const {
    reports_to: reportsTo,
    has_direct_reports: hasDirectReports,
    reporting_structure: reports
  } = reportingStructure || {};

  const hasDirectReportsToRender = renderHasDirectReports(hasDirectReports);

  return (
    <Section
      title={strings.inventory.jobOrders.profile.jobDescriptionTab.sections.reportingStructure}
    >
      <Section>
        <Grid container item>
          {isTruthyValue(reportsTo) && (
            <Grid item xs={12} sm={6} md={4}>
              <InfoLabel
                cropped={false}
                description={reportsTo}
                title="Reports To"
                variant="body1"
              />
            </Grid>
          )}

          {hasDirectReportsToRender && (
            <Grid item xs={12} sm={6} md={4}>
              <InfoLabel
                cropped={false}
                description={hasDirectReportsToRender}
                title="Has Direct Reports"
                variant="body1"
              />
            </Grid>
          )}

          {isTruthyValue(reports) && (
            <Grid item xs={12} sm={6} md={4}>
              <InfoLabel
                cropped={false}
                description={reports}
                title="Reporting Structure"
                variant="body1"
              />
            </Grid>
          )}
        </Grid>
      </Section>
    </Section>
  );
};
